import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseService } from '../services/base.service';
import { AppService } from 'src/app/app.service';

import { environment } from 'src/environments/environment';
import { IResponse } from 'src/app/shared/models/app';

import { ApiPrefix } from '../constants/api.constant';
import { Environment } from './environment';
import { AppConstant } from '../constants/app.constant';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService extends BaseService {
  /*********************Properties*********************/
  private environment: Environment = Environment.getInstance();
  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(
    protected http: HttpClient,
    private appService: AppService) {
    super(http);
  }
  /*********************Constructor*********************/

  /*********************Service Methods*********************/

  getConfig(): Promise<boolean> {
    this.environment.apiConfig = {
      bin:'',
      config:'',
      hp:'',
      inventory:'',
      nucbotDialog:'',
      nucbotProjectID:'',
      nucbotToken:'',
      order:'',
      patient:'',
      report:'',
      util:'',

    };
    return new Promise((resolve, reject) => {

      super
        .fetch('/env/prop', {})
        //.post('https://nps-usermgmt-stage.apps.cf.np.gc.cahcloud.net/value/getService', {})
        .subscribe((response: IResponse) => {
          if (!response.hasError) {
            this.onConfigResponse(response.data);
            this.appService.init();

            return this.appService.initOnLoad().then((load) => {
              if (load) {
                this.appService.load().then(() => {
                  resolve(true);
                });
              } else {
                resolve(true);
              }
            });
          }


          return resolve(false);
        });
    });
  }

  /*********************Service Methods*********************/

  /*********************Private Methods*********************/

  private onConfigResponse(response:any): void {
    this.environment.appConfig.apiKey = response.apikey;
    this.environment.appConfig.apigeeTokenEndpoint = response.apigeeTokenEndpoint;
    this.environment.oktaConfig.clientId = response.oktaClientId;
    this.environment.oktaConfig.oktaTokenEndpoint = response.oktaTokenEndpoint;
    this.environment.apiConfig.util=response.utilUrl;
    this.environment.appConfig.nuctrac340BEmailInquires = response.nuctrac340BEmailInquires;
    this.environment.appConfig.wdNrcGuideUrl = response.wdNrcGuideUrl;
    this.environment.appConfig.idleTimeoutInSec = response.idleTimeoutInSec;

    this.environment.apiConfig = {
      bin:response.bin,
      config:response.config,
      hp:response.hp,
      inventory:response.inventory,
      nucbotDialog:response.nucbotDialogflow,
      nucbotProjectID:response.nucbotProjectID,
      nucbotToken:response.nucbotToken,
      order:response.order,
      patient:response.patient,
      report:response.report,
      util:response.util

    };


  }

  // private setPropLocalUrls() {

  // //To Run in local, copy API key from environment.local.env file present at root.
  //   this.environment.appConfig.apiKey = process.env.APIKEY;
  //   this.environment.appConfig.apigeeTokenEndpoint = "https://api.stage.cardinalhealth.com/oauth2/v3/token/jwtforoktab2b";
  //   this.environment.oktaConfig.clientId = '0oazk1v3ucUZFY6G70h7';
  //   this.environment.oktaConfig.oktaTokenEndpoint = 'https://myidb2bstg.cardinalhealth.com/oauth2/v1/token';
  //   this.environment.apiConfig.util="https://api.stage.cardinalhealth.com/nphs/nuctrac-utility/v1";

  //   this.environment.apiConfig = {
  //     bin:"https://api.stage.cardinalhealth.com/nphs/nuctrac-bin/v1",
  //     config:"https://api.stage.cardinalhealth.com/nphs/nuctrac-config/v1",
  //     hp:"https://api.stage.cardinalhealth.com/nphs/nuctrac-hp/v1",
  //     inventory:"https://api.stage.cardinalhealth.com/nphs/nuctrac-inventory/v1",
  //     nucbotDialog:"https://api.stage.cardinalhealth.com/nphs/nuctrac-bot/v1/api/dialogflow",
  //     nucbotProjectID:"nphs-comm-np-cah",
  //     nucbotToken:"https://api.stage.cardinalhealth.com/nphs/nuctrac-config/v1",
  //     order:"https://api.stage.cardinalhealth.com/nphs/nuctrac-order/v1",
  //     patient:"https://api.stage.cardinalhealth.com/nphs/nuctrac-patient/v1",
  //     report:"https://api.stage.cardinalhealth.com/nphs/nuctrac-report/v1", // +'/' Check this
  //     util:"https://api.stage.cardinalhealth.com/nphs/nuctrac-utility/v1"

  //   };
  // }

  /*********************Private Methods*********************/
}
